import { useQuery } from '@tanstack/react-query';

import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';

type PortfoliosQueryRes = string[];

const decoratedAxiosGet = axiosGetAutoCancelDecorator();

export function useFetchPortfolios() {
  const portfoliosQueryRes = useQuery(['portfolios'], () =>
    decoratedAxiosGet('/portfolios').then(({ data = [] }) => data as PortfoliosQueryRes),
  );

  return portfoliosQueryRes;
}
